<template>
  <nav class="navbar navbar-expand-lg navbar-transparent">
    <div class="container-fluid">
      <div class="navbar-wrapper">
        <div class="navbar-minimize d-inline">
          <!-- <button class="minimize-sidebar btn btn-link btn-just-icon" rel="tooltip" data-original-title="Sidebar toggle" data-placement="right">
                <i class="tim-icons icon-align-center visible-on-sidebar-regular"></i>
                <i class="tim-icons icon-bullet-list-67 visible-on-sidebar-mini"></i>
              </button> -->
        </div>
        <div class="navbar-toggle d-inline">
          <button type="button" class="navbar-toggler">
            <span class="navbar-toggler-bar bar1"></span>
            <span class="navbar-toggler-bar bar2"></span>
            <span class="navbar-toggler-bar bar3"></span>
          </button>
        </div>
        <router-link to="/" class="navbar-brand">
        <div class="row center-para">
          <div>
            <img :src="logo" id="navbar-logo"/>
            <span class="envHeader">{{configHeader}}</span>
          </div>
        </div>
        </router-link>
      </div>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navigation"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-bar navbar-kebab"></span>
        <span class="navbar-toggler-bar navbar-kebab"></span>
        <span class="navbar-toggler-bar navbar-kebab"></span>
      </button>
      <div class="collapse navbar-collapse" id="navigation">
        <ul class="navbar-nav ml-auto">
          <li class="dropdown nav-item">
            <a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown">
              <i class="fas fa-user"></i>
              <b class="caret d-none d-lg-block d-xl-block"></b>
              <p class="d-lg-none">
                Log out
              </p>
            </a>
            <ul class="dropdown-menu dropdown-navbar">
              <li class="nav-link">
                <a href="javascript:void(0)" class="nav-item dropdown-item" @click="signOut()"
                  >Log out</a
                >
              </li>
            </ul>
          </li>
          <li class="separator d-lg-none"></li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import firebase from 'firebase/app'
import tokenManagerService from '../services/tokenManager';

export default {
    methods: {
        signOut() {
					console.log('Logging out...')
          tokenManagerService.logout()
        }
    },
    computed: {
      isStaging() {
        return this.$store.getters.isStaging
      },
      configHeader() {
        if(this.isStaging){
          return "STAGING"
        }
        return "PROD"
    },
      logo() {
        try{
          if (this.$route.name != "Home"){
          const appId = this.$route.params.aid
          if (this.isStaging){
            try {
              return require(`@/assets/images/${appId}-staging.png`)
            } catch (error) {
              return require(`@/assets/images/${appId}.png`)
            }
          }else {
            return require(`@/assets/images/${appId}.png`)
          }
        }else{
          return require('@/assets/images/logo.png')
        }
        }
        catch(err){
          console.error("Error encountered while setting logo: ",err)
          return require('@/assets/images/logo.png')
        }
        
      }
    }
}
</script>

<style>
#navbar-logo {
  width: 40px;
}

.envHeader{
font-weight: bold; font-size: 20px; margin: auto; margin-left: 5px
}
</style>